import style from './Rating.module.scss'
import starActiveIcon from '../assets/icons/starActive.svg'
import starInactiveIcon from '../assets/icons/starInactive.svg'

interface IRatingProps {
  rating: number
}

const STARS = [0, 1, 2, 3, 4]

// Same rounding as the sibling stores: .8 and up fills the star, .3-.7 fills half of it.
const starFill = (rating: number, index: number) => {
  const whole = Math.floor(rating)
  const decimal = Math.round((rating % 1) * 10) / 10
  if (index < whole) return 100
  if (index === whole && decimal >= 0.8) return 100
  if (index === whole && decimal >= 0.3) return 50
  return 0
}

const Rating = ({ rating }: IRatingProps) => (
  <span className={style.stars}>
    {STARS.map(index => {
      const fill = starFill(rating, index)
      return (
        <span key={index} className={style.star}>
          <img src={starInactiveIcon} alt="" role="presentation" className={style.starIcon} />
          {fill > 0 && (
            <span className={style.starFill} style={{ width: `${fill}%` }}>
              <img src={starActiveIcon} alt="" role="presentation" className={style.starIcon} />
            </span>
          )}
        </span>
      )
    })}
  </span>
)

export default Rating
